module.exports = __webpack_public_path__ + "21b7b6d7cc4c6e8024d0e95c4baf5808.svg";